/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import {
  type CdfDisplayMetadata,
  getCdfDisplayMetadata,
  getCdfDisplayTitle,
} from './cdfDisplayMetadata'
import { ExcelDownloadButton } from './components/ExcelDownloadButton'
import { Histogram } from './components/Histogram'
import { CreateCdfParams, RawCdfEntry } from './customCdfs/cdfGenerator'
import { useCreateCustomCdf } from './customCdfs/useCreateCustomCdf'
import { DataLayerProvider } from './DataLayerProvider'
import {
  callEmatCombinedCategoryWorker,
  useEmatCombinedCategoryData,
} from './ematCategoricalHelpers'
import {
  atBuffer2DIndex,
  atBufferCoord,
  createBinnedDataBufferFromData,
  createBinnedDataBufferFromSerialized,
  EMPTY_BINNED_DATA_BUFFER,
  GeckoBinnedDataBuffer,
  GeckoBinnedDataBufferSerializable,
  serializeBinnedDataBuffer,
} from './geckoBinnedDataBuffer'
import { calculateCorrosionMultiplier } from './generation/calculations/calculateCorrosionRateMultiplier'
import {
  calculateDerivedValues,
  createMethodTminSource,
  FindCustomCrForShellCourseFn,
  getFindCustomCrForShellCourseFn,
  getJointEfficiency,
  getJointEfficiencyBufferRectsFromWeldLines,
  getLossBinValueFunction,
  getLossPerYearBinValueFunction,
  getRcaBinValueFunction,
  getRlBinValueFunction,
  getShellCourseNumForBinRect,
  getStressToleranceForBinRect,
  getTminBinValueFunction,
  type SerializedTminSource,
  THICKNESS_CDF_SIGNIFICANT_DIGITS,
  type TminSource,
} from './generation/calculations/calculateDerivedValues'
import { CalculateBinValueFunction } from './generation/calculations/calculateDerivedValuesHelpers'
import {
  getMawpBinValueFunction,
  getStructuralTmin,
} from './generation/calculations/calculateDerivedValuesPipe'
import { interpolateGravity } from './generation/calculations/calculateInterpolatedSpecificGravity'
import {
  type BinValueFunctions,
  getBinValueFunctions,
} from './generation/calculations/getBinValueFunctions'
import {
  getNominalBaseData,
  NominalBaseData,
  useGenerateNominalCDFs,
} from './generation/coreLayers/nominal/generateNominalCDF'
import { useGenerateLossByPercentageCDFs } from './generation/coreLayers/wastage/generateLossByPercentageCDFs'
import { handleCreateExcelSheet } from './generation/excel/excelGeneration'
import {
  CommercialFdeCdfSpecificationList,
  FdeCdfSpecification,
  FdeCdfSpecificationList,
} from './generation/fdeCdfSpecification'
import {
  ParamOverrides,
  useGenerateDerivedDataInWebWorker,
  useGetGenerateAllValidSpecifiedCdfsFromBaseFn,
  useGetGenerateAndUploadDerivedCdfFn,
  useGetGenerateDerivedValuesInWebWorkerFn,
  useHandleEmatOnDemandGeneration,
} from './generation/useGenerateDerivedCdfData'
import { useInitializeDerivedCdfsFromRolodexData } from './initialization/useInitializeDerivedDataLayers'
import { getMultipleCdfBinReadings } from './load/getMultipleCdfBinReadings'
import { CategoricalSummaryStatistics } from './load/summaryStats/categoricalStats/categoricalStatisticsDataType'
import { useCategoricalDataSummaryStatsFetcher } from './load/summaryStats/categoricalStats/useCategoricalDataSummaryStatsFetcher'
import {
  GeckoSummaryStatisticsHistogram,
  QuantitativeSummaryStatistics,
} from './load/summaryStats/quantitativeStats/quantitativeStatisticsDataType'
import { useQuantitativeDataSummaryStats } from './load/summaryStats/quantitativeStats/useQuantitativeDataSummaryStats'
import {
  useCdfSummaryStatsFetcher,
  useFetchSummaryStatsSwr,
} from './load/summaryStats/useSummaryStatsFetcher'
import { useBinnedDataBufferCache } from './load/useBinnedDataBufferCache'
import {
  useCdfBinReading,
  useMultipleCdfBinReadings,
  useMultipleCdfBinReadingsRawValues,
} from './load/useCdfBinReading'
import { useCdfDataFetcher } from './load/useCdfDataFetcher'
import { useMultiCDFRaw2D } from './load/useCdfMulti2D'
import { useCdfRawValues } from './load/useCdfRawValues'
import {
  useCdfRawValues2DArray,
  useGetCdf2dDataFetcher,
} from './load/useCdfRawValues2DArray'
import {
  determineDefaultColorScaleThreshold,
  determineDefaultColorScaleThresholdNonCdf,
  useColorScale,
  useColorScaleNonCdf,
} from './useColorScale'

export {
  atBuffer2DIndex,
  atBufferCoord,
  type BinValueFunctions,
  type CalculateBinValueFunction,
  calculateCorrosionMultiplier,
  calculateDerivedValues,
  callEmatCombinedCategoryWorker,
  type CategoricalSummaryStatistics,
  type CdfDisplayMetadata,
  CommercialFdeCdfSpecificationList,
  createBinnedDataBufferFromData,
  createBinnedDataBufferFromSerialized,
  type CreateCdfParams,
  createMethodTminSource,
  DataLayerProvider,
  determineDefaultColorScaleThreshold,
  determineDefaultColorScaleThresholdNonCdf,
  EMPTY_BINNED_DATA_BUFFER,
  ExcelDownloadButton,
  FdeCdfSpecification,
  FdeCdfSpecificationList,
  type FindCustomCrForShellCourseFn,
  type GeckoBinnedDataBuffer,
  type GeckoBinnedDataBufferSerializable,
  type GeckoSummaryStatisticsHistogram,
  getBinValueFunctions,
  getCdfDisplayMetadata,
  getCdfDisplayTitle,
  getFindCustomCrForShellCourseFn,
  getJointEfficiency,
  getJointEfficiencyBufferRectsFromWeldLines,
  getLossBinValueFunction,
  getLossPerYearBinValueFunction,
  getMawpBinValueFunction,
  getMultipleCdfBinReadings,
  getNominalBaseData,
  getRcaBinValueFunction,
  getRlBinValueFunction,
  getShellCourseNumForBinRect,
  getStressToleranceForBinRect,
  getStructuralTmin,
  getTminBinValueFunction,
  handleCreateExcelSheet,
  Histogram,
  interpolateGravity,
  type NominalBaseData,
  type ParamOverrides,
  type QuantitativeSummaryStatistics,
  type RawCdfEntry,
  serializeBinnedDataBuffer,
  type SerializedTminSource,
  THICKNESS_CDF_SIGNIFICANT_DIGITS,
  type TminSource,
  useBinnedDataBufferCache,
  useCategoricalDataSummaryStatsFetcher,
  useCdfBinReading,
  useCdfDataFetcher,
  useCdfRawValues,
  useCdfRawValues2DArray,
  useCdfSummaryStatsFetcher,
  useColorScale,
  useColorScaleNonCdf,
  useCreateCustomCdf,
  useEmatCombinedCategoryData,
  useFetchSummaryStatsSwr,
  useGenerateDerivedDataInWebWorker,
  useGenerateLossByPercentageCDFs,
  useGenerateNominalCDFs,
  useGetCdf2dDataFetcher,
  useGetGenerateAllValidSpecifiedCdfsFromBaseFn,
  useGetGenerateAndUploadDerivedCdfFn,
  useGetGenerateDerivedValuesInWebWorkerFn,
  useHandleEmatOnDemandGeneration,
  useInitializeDerivedCdfsFromRolodexData,
  useMultiCDFRaw2D,
  useMultipleCdfBinReadings,
  useMultipleCdfBinReadingsRawValues,
  useQuantitativeDataSummaryStats,
}
